import React, { useState } from 'react';
import { Collapse } from 'antd';
import classNames from 'classnames/bind';
import { ICategory, IQuestion } from 'sections/Company/Faqs/types';
import { NavigationItem } from 'sections/Company/Faqs/SectionContent/Navigation/NavigationItem';
import { useUtils } from 'utils/hooks/useUtils';
import styles from 'sections/Company/Faqs/SectionContent/Navigation/Navigation.module.scss';

const cn = classNames.bind(styles);

interface NavigationProps {
  categories: ICategory[];
  activeCategoryId: number | null;
  setActiveCategoryId: (id: number) => void;
  setActiveCategoryItems: ([]: IQuestion[]) => void;
  activeQuestionId: number | null;
  activeParentId: number | null;
};

const Navigation = ({
  categories,
  activeCategoryId,
  setActiveCategoryId,
  setActiveCategoryItems,
  activeParentId,
}: NavigationProps) => {
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const { Panel } = Collapse;
  const { renderQuestions } = useUtils();

  const onClickHandler = (event: React.MouseEvent<HTMLElement>, id: number) => {
    event.stopPropagation();
    setActiveCategoryId(id);
    setActiveCategoryItems(renderQuestions(categories, id));
  };

  const outputElements = (array: ICategory[]) => {
    return array?.map((item: ICategory) => {
      return (
        //@ts-ignore
        <NavigationItem
          key={item.id}
          item={item}
          hideLabel={!item.children}
          isActive={item.id === activeCategoryId && !item.children}
          action={onClickHandler}
        >
          {/*//@ts-ignore*/}
          {item.children ? (
            <>
              {/*//@ts-ignore*/}
              <Collapse
                accordion
                ghost
                defaultActiveKey={[activeParentId || 0]}
                onChange={() => setIsOpened(!isOpened)}
              >
                {/*//@ts-ignore*/}
                <Panel
                  key={item.id}
                  showArrow={false}
                  header={
                    <span className={cn('navigation__text', { 'isMain': !item.parent_id })}>
                      {item.name}
                    </span>
                  }
                >
                  <ul className={cn('navigation__sublist')}>{outputElements(item.children)}</ul>
                </Panel>
              </Collapse>
            </>
          ) : null}
        </NavigationItem>
      );
    });
  };

  return <ul className={cn('navigation')}>{outputElements(categories)}</ul>;
};

export { Navigation };
